import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

// style, design
import ModalChapter from "../../Base/Chapters/ModalChapter";

// store, state
import chapterDefs from "./chapterDefs";
import {
  constants,
  useUserForm,
  destroyPatchForm,
  update,
} from "../../../../store/users";
import renderChapter from "./renderChapter";
import { updateActiveFormInstance } from "../../../../store/base";
import { cloneDeep } from "lodash";

export default ({
  method,
  id,
  isOpen,
  onCheckout,
  existingData,
  skipRedirect,
}) => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const [loading, setLoading] = React.useState(false);
  const formLoaded = Boolean(useUserForm(method, id));

  React.useEffect(() => {
    if (formLoaded && existingData) {
      dispatch(
        updateActiveFormInstance({
          storeName: constants.STORE_NAME,
          data: { ...existingData },
        })
      );
    }
  }, [formLoaded, isOpen]);

  React.useEffect(() => {
    return () => {
      dispatch(destroyPatchForm(false));
    };
  }, []);

  const checkout = (success, data) => {
    dispatch(destroyPatchForm(success));
    onCheckout(data);
  };

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true, returned);
  };

  const preProcess = (data) => {
    const dataClone = cloneDeep(data);
    dataClone.realestates = dataClone.realestates.map((r) => {
      return { id: r };
    });

    return dataClone;
  };

  const onSubmit = () => {
    setLoading(true);

    dispatch(
      update({
        id,
        preProcess,
        successCallback: onSuccess,
        errorCallback: () => setLoading(false),
      })
    );
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <ModalChapter
      storeName={constants.STORE_NAME}
      chapterDefs={chapterDefs}
      onRenderChapter={(key) => renderChapter(key, method)}
      submitCallback={onSubmit}
      title={method === "POST" ? "Skapa användare" : "Uppdatera användare"}
      onDone={onDone}
      loading={!formLoaded || loading}
      isOpen={isOpen}
    />
  );
};
